import { CSvgAgents, CSvgApps, CSvgAttch, CSvgTrash } from "icon"
import BotImg from 'media/chat/bot.png'

export const ConvertionChatCont = () => {



  return (
    <div className="w-full md:h-full h-[400px] bg-hoory-100 rounded-lg flex flex-col justify-between ">
      <div className="w-full py-2 flex items-center justify-between border-b border-hoory-75 md:px-[20px] px-[10px]">
        <div className="flex items-center">
          <div className="md:w-[50px] w-[40px] md:h-[50px] h-[40px] bg-hoory-175 flex items-center justify-center text-hoory-200 rounded-full shadow">
            <CSvgAgents className="fill-hoory-200 w-[25px]" />
          </div>
          <div className="ml-2 flex flex-col items-start">
            <span className="text-sm">Ehsan Aghahoseini</span>
            <span className="text-gray-400 text-xs ">Last Seen 3:55 PM</span>
          </div>
        </div>
        <div className="flex items-center">
          <button className="w-[30px] h-[30px] mx-1 rounded-md bg-hoory-175 flex items-center justify-center"><CSvgApps className="w-[15px]" /></button>
          <button className="w-[30px] h-[30px] mx-1 rounded-md bg-hoory-175 flex items-center justify-center"><CSvgTrash className="fill-hoory-200 h-[15px]" /></button>
          <button className="px-2 h-[30px] rounded-md  text-hoory-200 md:text-sm text-[12px] bg-hoory-175">Block</button>
        </div>
      </div>
      <div className="w-full h-full max-h-[480px] pb-[30px] pt-[15px] overflow-y-auto px-[20px]">
        {new Array(20).fill("").map((item: any, index: number) =>
          <div key={index} className={`w-full my-5  flex  ${index % 2 == 0 ? 'justify-start' : 'justify-end'} `}>
            <div className="md:w-[50%] w-[90%] relative flex flex-col">
              <div className={`w-[30px] h-[30px] absolute rounded-full overflow-hidden bg-gray-400 top-[-25px] ${index % 2 == 0 ? 'left-[20px]' : 'right-[20px]'}`}>
                <img src={BotImg} className="w-full h-full" />
              </div>
              <div className="w-full p-[15px] bg-hoory-125 rounded-lg flex flex-col mt-[-10px]">
                <div className={`w-full flex ${index % 2 == 0 && 'justify-end'}`}>
                  <span className="text-[12px] text-gray-600">10:14 am</span>
                </div>
                <span className="mt-2 text-sm leading-6">Are we meeting today? Project has been already finished and I have results to show you. </span>
              </div>
            </div>
          </div>
        )}
      </div>
      <form className="w-full py-4  md:px-[20px] px-[10px] border-t border-hoory-75 flex items-center justify-between ">
        <div className="w-[35px] h-[35px] rounded-md flex items-center justify-center bg-hoory-125 cursor-pointer">
          <CSvgAttch className="w-[25px] stroke-gray-500" />
        </div>
        <input placeholder="Type message" className="md:w-[calc(100%-150px)] w-[calc(100%-120px)] h-[35px] px-2 text-sm focus:outline-none border border-hoory-75 rounded-md bg-transparent" />
        <button type="submit" className="md:w-[100px] w-[70px] h-[35px] flex items-center justify-center text-sm bg-hoory-175 text-hoory-200 rounded-md">Send</button>
      </form>
    </div>
  )
}